<template>
	<svg
    class="GraphShow"
		style="touch-action: none; background-color: #fff; display:block; user-select: none; -webkit-user-select: none; -webkit-touch-callout: none;"
	>
		<g
      ref="canvas"
      v-show="vectorDataExists"
    ></g>

    <text
      v-if="this.vectorData !== null && !vectorDataExists"
      class="empty"
      x="50%"
      y="50%"
      dominant-baseline="middle"
      text-anchor="middle">{{ $t( "empty" ) }}</text>
	</svg>
</template>

<script>
import { moveEvtMobileFix } from "./libs/diagram/infrastructure/move-evt-mobile-fix.js";
import { CanvasSmbl } from "./libs/diagram/infrastructure/canvas-smbl.js";
import { moveScaleApplay } from "./libs/diagram/infrastructure/move-scale-applay.js";
import { evtRouteApplay } from "./libs/diagram/infrastructure/evt-route-applay.js";
import { uiDisable } from "./libs/diagram/ui/ui.js";
import { deserialize } from "./libs/diagram/diagram/dgrm-serialization.js";
//import { copyPastApplay, groupSelectApplay } from "./libs/diagram/diagram/group-select-applay.js";
import { shapeTypeMap } from "./libs/diagram/shapes/shape-type-map.js";
import { ttlToDiagram } from "./ttlConverter.js";

export default {
	components: {
	},
	name: "GraphShow",

  props: {
	  ttl: {
	    type: String,
      default: null
    },

    id: {
	    type: String,
      default: null
    }
	},

  i18n: {
    messages: {
      ru: {
        empty: "невозможно построить граф связей объекта, возможно он их не имеет",
      },

      en: {
        empty: "Cannot build relations graph",
      },

      kz: {
        empty: "нысанның анықтамалық графигін құра алмайды, оның сілтемелері болмауы мүмкін",
      }
    }
  },

	data() {
		return {
		  canvas: null,
      centerX: 0,
      centerY: 0,
      vectorData: null
		};
	},

  async mounted() {
    const canvas = this.$refs.canvas;

    canvas[ CanvasSmbl ] = {
      data: {
        position: { x: 0, y: 0 },
        scale: 1,
        cell: 24
      },
      shapeMap: shapeTypeMap( canvas ),
      api: {}
    };

    moveEvtMobileFix( canvas.ownerSVGElement );
    evtRouteApplay( canvas.ownerSVGElement );
//    copyPastApplay( canvas );
//    groupSelectApplay( canvas ); // groupSelectApplay must go before moveScaleApplay
    moveScaleApplay( canvas );

    uiDisable( false );

    this.canvas = canvas;

    const p = this.canvas.parentNode.getBoundingClientRect();
    if ( p ) {
      this.centerX = - -p.width / 2;
      this.centerY = - -p.height / 2;
    }
  },

  computed: {
    vectorDataExists() {
      return this.vectorData && this.vectorData.s && this.vectorData.s.length;
    }
  },

  watch: {
	  ttl: {
	    immediate: true,
      async handler( val ) {
	      if ( !this.canvas || !val ) return;

        this.vectorData = await ttlToDiagram( val, this.centerX, this.centerY, this.id );
        deserialize( this.canvas, this.vectorData, false );
        //reorder objects to make them above all their connections
        Array.from( this.canvas.querySelectorAll( ".shrect" ) ).forEach(
          i => {
            this.canvas.appendChild( i );
          }
        );

        const canvasData = this.canvas[ CanvasSmbl ];
        canvasData.api.scale(
          0.25,
          {
            x: this.centerX,
            y: this.centerY
          }
        );
      }
    }
  }
};
</script>

<style>
.GraphShow {
  box-sizing: border-box;
  width: 100%;
  height: calc( 100% - 3em );
}
.GraphShow text {
  white-space: pre-wrap;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  color: rgb(73, 80, 87);
  font-weight: bold;
}
.GraphShow text tspan:nth-child(n+2){
  font-size: 0.8em;
  fill: #000000;
  font-weight: normal;
}

.GraphShow textarea {
  text-align: center;
  border: none;;
  padding: 10px;
  padding-top: 0.8em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  background-color: transparent;
  color: transparent;
  outline: none;
  overflow: hidden;
  resize: none;
  line-height: 1em;
  caret-color: #fff;
}

.GraphShow *[data-connect] {
  display: none;
}

.GraphShow .select path[data-key="selected"],
.GraphShow .select .path-end,
.GraphShow .select *[data-connect],
.GraphShow .highlight-e *[data-key="end"] .path-end,
.GraphShow .highlight-s *[data-key="start"] .path-end,
.GraphShow .hover *[data-connect] {
  display: unset;
  opacity: 0.51;
  stroke: rgb(108 187 247);
  fill: rgb(108 187 247);
}

.GraphShow *[data-connect].hover {
  stroke-width: 25px;
}

.GraphShow .select path[data-key="selected"] {
  fill: none;
}

.GraphShow .highlight *[data-key="main"] {
  paint-order: stroke;
  stroke-width: 10px;
  stroke: rgb(108 187 247 / 51%);
}

.GraphShow .shpath *[data-key="end"] .path,
.GraphShow .shpath *[data-key="start"] .path {
  display: none;
}

.GraphShow .shpath.arw-e *[data-key="end"] .path,
.GraphShow .shpath.arw-s *[data-key="start"] .path {
  display: unset;
}

.GraphShow .shpath.dash *[data-key="path"] {
  stroke-dasharray: 5;
}

@media (pointer: coarse) {
  .GraphShow circle.path-end {
    r: 20px;
  }

  .GraphShow .ative-elem {
    stroke: rgb(108 187 247 / 51%);
    stroke-width: 70px;
  }

  .GraphShow *[data-connect] {
    stroke-width: 15px;
  }

  .GraphShow *[data-connect].hover {
    stroke-width: 70px;
  }
}


/* rect, text shape */
.GraphShow .shrect.ta-1 text, .shtxt.ta-1 text {
  text-anchor: start;
}

.GraphShow .shrect.ta-2 text, .shtxt.ta-2 text {
  text-anchor: middle;
}

.GraphShow .shrect.ta-3 text, .shtxt.ta-3 text {
  text-anchor: end;
}

.GraphShow .shrect.ta-1 textarea, .shtxt.ta-1 textarea {
  text-align: left;
}

.GraphShow .shrect.ta-2 textarea, .shtxt.ta-2 textarea {
  text-align: center;
}

.GraphShow .shrect.ta-3 textarea, .shtxt.ta-3 textarea {
  text-align: right;
}

.GraphShow .shtxt textarea {
  caret-color: rgb(73, 80, 87);
}

.GraphShow .shtxt text {
  fill: rgb(73, 80, 87);
}

.GraphShow .shtxt *[data-key="main"] {
  fill: transparent;
  stroke: transparent;
}

.GraphShow .shtxt.select *[data-key="main"], .shtxt.highlight *[data-key="main"] {
  stroke: rgb(108 187 247 / 51%);
  stroke-width: 2px;
}

/* rhomb shape */
.GraphShow .shrhomb.highlight *[data-key="border"] {
  stroke-width: 28px;
  stroke: rgb(108 187 247 / 51%);
}

.GraphShow .shrhomb.highlight *[data-key="main"] {
  stroke-width: 18px;
  stroke: #1D809F;
}

/* shape settings styles */
.GraphShow .cl-red *[data-key="main"] {
  fill: #E74C3C;
}

.GraphShow .cl-red .path {
  stroke: #E74C3C;
}

.GraphShow .cl-orange *[data-key="main"] {
  fill: #ff6600;
}

.GraphShow .cl-orange .path {
  stroke: #ff6600;
}

.GraphShow .cl-green *[data-key="main"] {
  fill: #19bc9b;
}

.GraphShow .cl-green .path {
  stroke: #19bc9b;
}

.GraphShow .cl-blue *[data-key="main"] {
  fill: #1aaee5;
}

.GraphShow .cl-blue .path {
  stroke: #1aaee5;
}

.GraphShow .cl-dblue *[data-key="main"] {
  fill: #1D809F;
}

.GraphShow .cl-dblue .path {
  stroke: #1D809F;
}

.GraphShow .cl-dgray *[data-key="main"] {
  fill: #495057;
}

.GraphShow .cl-dgray .path {
  stroke: #495057;
}

.GraphShow .shtxt.cl-red *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-red text {
  fill: #E74C3C;
}

.GraphShow .shtxt.cl-orange *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-orange text {
  fill: #ff6600;
}

.GraphShow .shtxt.cl-green *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-green text {
  fill: #19bc9b;
}

.GraphShow .shtxt.cl-blue *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-blue text {
  fill: #1aaee5;
}

.GraphShow .shtxt.cl-dblue *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-dblue text {
  fill: #1D809F;
}

.GraphShow .shtxt.cl-dgray *[data-key="main"] {
  fill: transparent;
}

.GraphShow .shtxt.cl-dgray text {
  fill: #495057;
}

.GraphShow .shrhomb.cl-red *[data-key="main"] {
  stroke-width: 18px;
  stroke: #E74C3C;
}

.GraphShow .shrhomb.cl-orange *[data-key="main"] {
  stroke-width: 18px;
  stroke: #ff6600;
}

.GraphShow .shrhomb.cl-green *[data-key="main"] {
  stroke-width: 18px;
  stroke: #19bc9b;
}

.GraphShow .shrhomb.cl-blue *[data-key="main"] {
  stroke-width: 18px;
  stroke: #1aaee5;
}

.GraphShow .shrhomb.cl-dblue *[data-key="main"] {
  stroke-width: 18px;
  stroke: #1D809F;
}

.GraphShow .shrhomb.cl-dgray *[data-key="main"] {
  stroke-width: 18px;
  stroke: #495057;
}

.GraphShow .linkTitle {
  font-weight: normal;
  color: #FF0000;
  text-shadow: -0 -1px 1px #FFFFFF,
  0 -1px 1px #FFFFFF,
  -0 1px 1px #FFFFFF,
  0 1px 1px #FFFFFF,
  -1px -0 1px #FFFFFF,
  1px -0 1px #FFFFFF,
  -1px 0 1px #FFFFFF,
  1px 0 1px #FFFFFF,
  -1px -1px 1px #FFFFFF,
  1px -1px 1px #FFFFFF,
  -1px 1px 1px #FFFFFF,
  1px 1px 1px #FFFFFF,
  -1px -1px 1px #FFFFFF,
  1px -1px 1px #FFFFFF,
  -1px 1px 1px #FFFFFF,
  1px 1px 1px #FFFFFF;
}

.GraphShow .txtline1 {
  font-size: 0.8em;
  color: #000000;
}

.GraphShow text.empty {
  fill: #007bc1;
  font-weight: bold;
}
</style>


